import pipefitterApi from '../../../services/pipefitterApi';

export interface MovePipesToPipeSizePayload {
  projectNumber: string;
  pipeStatusIds: number[];
  targetPipeId: number;
  targetGroupId: string;
  /** @deprecated Move changes Group ID only — OD/wall are never updated. Kept optional for older callers. */
  targetPipeOd?: string;
  targetThickness?: string;
  recalculateMinMax?: boolean;
}

export interface MovePipeResultItem {
  pipeStatusId: number;
  sourcePipeStatusId?: number;
  mergedIntoPipeStatusId?: number;
  sourceDeleted?: boolean;
  pipeID?: string;
  oldGroupID?: string;
  newGroupID?: string;
  success: boolean;
  error?: string;
  s3?: unknown;
}

export interface MovePipesToPipeSizeResult {
  projectNumber?: string;
  targetGroupId?: string;
  targetPipeId?: number;
  results: MovePipeResultItem[];
}

function unwrapData<T>(responseData: any): T {
  if (responseData?.data != null) return responseData.data as T;
  return responseData as T;
}

/** Move pipe(s) to another pipe size/group — server relocates S3 JSON + updates DB. No re-upload. */
export async function movePipesToPipeSize(
  payload: MovePipesToPipeSizePayload
): Promise<MovePipesToPipeSizeResult> {
  const response = await pipefitterApi.post('/reports/move-pipes-to-pipe-size', payload);
  if (response?.data?.status && response.data.status !== 200) {
    throw new Error(response.data.message || 'Failed to move pipe(s) to target pipe size');
  }
  return unwrapData<MovePipesToPipeSizeResult>(response.data);
}
